import VehicleTypeField from './VehicleTypeField';

export default VehicleTypeField;
